export default __webpack_public_path__ + "static/media/coding.8aa0adea.png";